<template>
  <div class="container mx-auto px-4 bg-white h-screen">
    <div class="px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header>{{$t('all.family')}}</Header>
      <p class="text-blue-dark">
        {{$t('all.profile_insert_fiscal')}}
      </p>
      <div class="pt-4">
        <p class="pb-2">
          <i class="text-xs">{{$t('all.profile_fiscal_code')}}</i><br>
          <input
            class="p-2 w-full border-b-2 border-grey"
            type="text"
            v-model="cf"
            name="cf"
          >
        </p>
      </div>
      <div
        v-if="message != ''"
        class="py-1 text-pink-dark text-sm border-2 p-2 mt-2 border-pink-dark"
      ><i>{{ message }}</i></div>
      <div
        class="rounded-full mt-5 p-4 py-2 bg-pink-dark text-white text-center cursor-pointer"
        @click="getFamiliariByCf({ id, cf })"
      >{{$t('all.profile_associate')}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id'],
  data() {
    return {
      cf: '',
    };
  },
  computed: {
    ...mapGetters({
      message: 'familiari/message',
    }),
  },
  methods: {
    ...mapActions('familiari', ['getFamiliariByCf']),
  },
};
</script>
